module.exports = __webpack_public_path__ + "media/images/footer-bullet-57cf09c6ca53050a9e63bc6571e25274.png";